/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import modelValidationClient from '@/services/modelValidationClient';

import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESET_ERROR,
  AUTH_2FA,
  SET_USERNAME,
  SET_RAILS,
  UPDATE_SUBMITTED_QUESTIONNAIRES
} from "../actions/auth";
import { ROLES } from '@/helpers/actionRoles';

const state = {
  token: localStorage.getItem('user-token') || '',
  role: localStorage.getItem('user-role') || '',
  userName: localStorage.getItem('user-name') || '',
  userId: localStorage.getItem('user-id') || '',
  tenantId: localStorage.getItem('tenantId') || '',
  fiList: [],
  userProfile: null,
  status: '',
  hasLoadedOnce: false,
  errors: null,
  managerId: '',
  submittedQuestionnaires: [],
  tenantRails: [],
};

const getters = {
  isAuthenticated: (state) =>
    !!(
      state.token &&
      state.token !== 'undefined' &&
      state.token !== '' &&
      state.token !== null
    ),
  authStatus: (state) => state.status,
  hasError: (state) => state.status === 'error',
  userRole: (state) => state.role,
  userName: (state) => state.userName,
  userFullName: (state) => state.userFullName,
  userId: (state) => state.userId,
  tenantId: (state) => state.tenantId,
  submittedQuestionnaires: (state) => state.submittedQuestionnaires,
  tenantRails: (state) => state.tenantRails,
  fiList: (state) => state.fiList,
  managerId: (state) => state.managerId,
  userGroup: (state) => state.userGroup,
  errors: (state) => state.errors,
};

const actions = {
  [AUTH_REQUEST]: ({ commit }, user) =>
    new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      modelValidationClient
        .login(user)
        .then((resp) => {
          const resultData = resp.data;
          if (resultData.user.passwordResetRequired) {
            commit(AUTH_SUCCESS, resultData);
            resolve(resultData);
            return;
          }
          commit(AUTH_SUCCESS, resultData);
          resolve(resp);
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    }),
  [AUTH_2FA]: ({ commit }, resultData) => commit(AUTH_SUCCESS, resultData),
  [SET_USERNAME]: ({ commit }, username) => commit(SET_USERNAME, username),
  [UPDATE_SUBMITTED_QUESTIONNAIRES]: ({ commit }, submittedQuestionnaires) => commit(UPDATE_SUBMITTED_QUESTIONNAIRES, submittedQuestionnaires),

  [SET_RAILS]: ({ commit }, rails) => commit(SET_RAILS, rails),

  // eslint-disable-next-line no-unused-vars
  [AUTH_LOGOUT]: async ({ commit }, userName) => {
    await modelValidationClient.logout(userName)
    localStorage.clear();
    commit(AUTH_LOGOUT);
  },
  [AUTH_RESET_ERROR]: ({ commit }) => {
    
    state.status = '';
    commit(AUTH_RESET_ERROR);
  }
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, resp) => {
    localStorage.setItem('user-token', resp.token);
    localStorage.setItem('user-role', resp.user.role);
    localStorage.setItem('user-name', resp.user.username);
    localStorage.setItem('user-id', resp.user._id);
    localStorage.setItem('tenantId', resp.user.tenantId);
    localStorage.setItem('passwordConfig', JSON.stringify(resp.user.tenantPasswordConfig));  
    localStorage.setItem('assessmentRequest', resp.user.assessmentRequest);
    if (resp.user.role === ROLES.AUDITOR) {      
      state.fiList = resp.user.fiList
    }

    state.status = "success";
    state.token = resp.token;
    state.role = resp.role;
    state.userFullName = resp.user.userFullName;
    state.userName = resp.username;
    state.submittedQuestionnaires = resp.user.submittedQuestionnaires;
    state.tenantRails = resp.user.tenantRails;
    state.userProfile = resp;
    state.hasLoadedOnce = true;
    state.userId = resp.userId;
    state.tenantId = resp.tenantId;
  },
  [AUTH_ERROR]: (state, err) => {
    state.status = "error";
    state.errors = err.message;
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.userProfile = null;
    state.token = "";
    state.role = "";
    state.userName = "";
    state.status = "";
    state.tenantId = "";
    state.errors = null;
  },
  [SET_USERNAME]: (state, username) => state.userName = username,
  [UPDATE_SUBMITTED_QUESTIONNAIRES]: (state, submittedQuestionnaires) => {
    
    if (state.submittedQuestionnaires && !state.submittedQuestionnaires.includes(submittedQuestionnaires)) state.submittedQuestionnaires.push(submittedQuestionnaires)
    else if (!state.submittedQuestionnaires?.length) state.submittedQuestionnaires = [submittedQuestionnaires]
  },
  [SET_RAILS]: (state, rails) => state.tenantRails = rails,

  [AUTH_RESET_ERROR]: (state) => {
    
    state.status = '';
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
